import React, { useState , useEffect, useContext} from 'react';



import Logo from '../../images/logo.png';
import Naked from '../../images/naked.png';
import NigeriaLogo from '../../images/nigerialogo.png';
import Bvn from  '../../images/bvn.jpg';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeSlash, faInfo, faDashboard, faBookBookmark, faCalendar,
     faPuzzlePiece , faShieldAlt, faDiceOne, faBahtSign, faChartBar, faTools
    , faBell, faChevronDown, faArrowUp,
    faCloud,
    faPhone} from '@fortawesome/free-solid-svg-icons';
import HomeImg from '../../images/homebody.png';
import { Link, useNavigate, useParams } from 'react-router-dom'
import { ShareContext } from '../../context/sharecontext';

import IdLayout from '../../components/_layout';
import * as Constants from '../../Constants';
import tinData from '../../data/finger.json';
import IdInput from '../../components/idInput';
import IdSelect from '../../components/idSelect';
import LoadingImg from '../../images/loading.gif';
import JisAlert from '../../components/jisalert';

function Reports() {
    const { profile,raw,activeType,token } = useContext(ShareContext);
    const isPlatformAdmin = profile?.userType === 'Admin' || profile?.userType === 'superadmin';
    const [staySigned, setStaySigned] = useState(false)
    const [param, setParam] = useState({startdate:new Date(), enddate:new Date, usertype:'all', verifytype:'all', specificUserId:0, byEmail:'', companyId:0, reportType:'summary'})
    const [reports, setReports] = useState([]);
    const [isResult, setIsResult]= useState(false);
    const [err, setErr] = useState('');
    const [loading, setLoading] =useState(false);
    const [users, setUsers]= useState([]);
    // Admin/superadmin only — the bank picker. Without this, Admin had no way to scope a report
    // to "one company" other than By Email, which only pulls that one person's own ParentId-chain
    // subordinates, not the whole company a Com-Owner's own report sees — exactly why Admin and a
    // Com-Owner running a report on the "same" company used to get different totals.
    const [companies, setCompanies] = useState([]);
    // Lets Admin/superadmin type to narrow the Company dropdown instead of scrolling a long,
    // alphabetically-ordered list — purely a client-side filter over the already-loaded
    // `companies` list, no extra API call per keystroke.
    const [companySearch, setCompanySearch] = useState('');
    const [totalunit, setTotalUnit]=useState(0);
    const [show,setShow] = useState(false);
    // Detail Report / Face Match & Liveness: null = closed, 'loading', 'error', or
    // {referenceImage, capturedImage} once fetched from GET Verification/{id}/images. Only shown
    // when a row's hasImages flag says the bank had image retention on for that attempt.
    const [imagesModal, setImagesModal] = useState(null);
   // const {type} = useParams(); 
    
    //const data=bvnData.ResponseData;

  console.log(tinData);

    useEffect(() => {

        Constants.seo({title:'Reports',metaDescription:''});
        if(profile?.canAddUser){
          Load();
        }
        if (isPlatformAdmin) {
          loadCompanies();
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Same `GET customer/companies` endpoint the bank picker on Verification Settings already
    // uses — reused here rather than inventing a second "list of banks" call.
    const loadCompanies = async () => {
      try {
        const resp = await fetch(`${Constants.rooturl}/customer/companies`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'Authorization': token },
        });
        const data = await resp.json();
        if (data.code === 0) {
          // `customer/companies` orders by CreateDate (newest first) for the company
          // *management* table (companies.jsx) — fine there, but a picker the size of the
          // whole customer base needs to be alphabetical to be findable at all. Sorted once
          // here rather than changing the shared endpoint, so companies.jsx keeps its own
          // newest-first order unaffected.
          const sorted = [...(data.coms || [])].sort((a, b) => (a.name || '').localeCompare(b.name || ''));
          setCompanies(sorted);
        }
      } catch (error) {
        console.error(error);
      }
    };

    // Picking a company also refreshes the "Select User" dropdown to that company's own users
    // (GetReport now accepts companyId for Admin/superadmin), so the dropdown matches what that
    // bank's own Com-Owner(s) would see, same as the report results themselves will once searched.
    const onCompanyChange = (e) => {
      const cid = Number(e.target.value);
      setParam({ ...param, companyId: cid, specificUserId: 0 });
      if (cid > 0) {
        Load(cid);
      } else {
        setUsers([]);
      }
    };

    const onPrint=()=>{
        window.print();
    }
    const types=[{value:'all',text:'All Verifiaction Type'},{value:'nin',text:'NIN'}, {value:'nin-phone',text:'Nin Search by Phone'}, {value:'nin-bvn',text:'Nin Search by BVN'},
       {value:'vnin',text:'Virtual Nin'}, {value:'nin-phone',text:'Nin Search by Phone'}, {value:'bvn',text:'Direct BVN'}, {value:'facematch-liveness',text:'Face Match & Liveness'}]

       const usertype =[{value:'all', text:'All User Type'},{value:'customer', text:'Customer'}, {value:'agent', text:'Agent'},  {value:'admin', text:'admin'}]
        const reportType =[{value:'summary',text:'Summary Report'}, {value:'details',text:'Details Report'}]
       const onSearch=async(e)=>{
        e.preventDefault(); 
        
  
          setLoading(true);
          
          try {
            var pp={...param,reportFormat:'web'}
            const resp = await fetch(`${Constants.rooturl}/verify/report/verify`, {
              method: 'POST',
              body:JSON.stringify(pp) ,
              headers: {
                'Content-Type': 'application/json, text/plain',
                'Authorization': token,
              },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if (data.code === 0) {
                //setGazettes(data.gazettes);
                setIsResult(true);
                setReports(data.reports);
                const totalUnits = data.reports.reduce((sum, item) => sum + item.unitUsed, 0);
                setTotalUnit(totalUnits);
            }else if(data.code == -1) {   
              setErr('issues');
            }
            else if(data.code == -2) {   
              setErr('issues');
            }
          } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
           // onMove();
          }
  
         }

         const onBack=()=>{
          setIsResult(false);
         }

         // "the images used on pop dialog for face match when [retained]" — fetches the reference
         // NIN photo + captured selfie for one facematch-liveness attempt and shows them in a modal.
         // The endpoint independently re-checks retention, so 'error' also covers the (should be
         // rare, since the row only offers this button when hasImages is true) case where the
         // images were never actually persisted for that attempt.
         const onViewImages=async(attemptId)=>{
          setImagesModal('loading');
          try {
            const resp = await fetch(`${Constants.rooturl}/Verification/${attemptId}/images`, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': token,
              },
            });
            const data = await resp.json();
            if (data.code === 0) {
              setImagesModal({ referenceImage: data.referenceImage, capturedImage: data.capturedImage });
            } else {
              setImagesModal('error');
            }
          } catch (error) {
            console.error(error);
            setImagesModal('error');
          }
         }

         const onCloseImagesModal=()=>{
          setImagesModal(null);
         }

         const Load=async(companyIdForUsers)=>{

          var urls=`${Constants.rooturl}/verify/report`;
          if (companyIdForUsers > 0) {
            urls += `?companyId=${companyIdForUsers}`;
          }
          try {
              setLoading(true);
              const resp = await fetch(urls, { 
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': token,
                  
                },
              });
              
              const data = await resp.json();
            
              setLoading(false);
              console.log(data);

              if (data.code === 0) {
                var _u=[];
                _u.push({value:0, text:`All`});
                data.users.forEach(user => {
                  _u.push({value:user.id, text:`${user.firstName} ${user.lastName==null?'':user.lastName}`});
                });

                setUsers(_u);
                  
              }else {    
                console.error(data.status);
              }
            } catch (error) {
              setLoading(false);
              console.error(error); 
            }
       }     

       const onDownloadExcel=async(e)=>{
        e.preventDefault(); 
          setLoading(true);
          
          try {
            var pp={...param,reportFormat:'excel'}
            const resp = await fetch(`${Constants.rooturl}/verify/report/verify`, {
              method: 'POST',
              body:JSON.stringify(pp) ,
              headers: {
                'Content-Type': 'application/json',
                'Authorization': token,
                'responseType': 'blob'
              },
            });
            
           const data = await resp.blob();
            setLoading(false);
            const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
            const link = document.createElement('a');
            link.download ="idverifyReport"// 'some.pdf';
            link.href = URL.createObjectURL(blob);
            link.click();
            

          } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
           // onMove();
          }
  
         }
      const onDownloadExcel2=async(e)=>{
        e.preventDefault(); 
          setLoading(true);
          
          try {
            var pp={...param,reportFormat:'excel'}
            const resp = await fetch(`${Constants.rooturl}/verify/report/verify`, {
              method: 'POST',
              body:JSON.stringify(pp) ,
              headers: {
                'Content-Type': 'application/json, text/plain',
                'Authorization': token,
          
              },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if (data.code === 0) {
                //setGazettes(data.gazettes);
                window.location.href=`${Constants.excelPath}${data.filename}`;
            }else if(data.code == -1) {   
              setErr('issues');
            }
            else if(data.code == -2) {   
              setErr('issues');
            }
          } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
           // onMove();
          }
  
         }

  return (

   <IdLayout active={'reports'} profile={profile}>
    <div style={{display:'flex',  flex:1,padding:8, flexDirection:'column'}}>
            <div style={{display:'flex', backgroundColor:'white', flex:1, flexDirection:'column'}}>

        {!isResult && <div>
            <h2>Report</h2>
            <form onSubmit={onSearch} >
              <div style={{display:'flex', flexDirection:'row'}}>
              <IdSelect onChange={(e)=> setParam({...param, reportType:e.target.value})} value={param.reportType} disabledText="Select Report Type" items={reportType} label='Report Type' required />
                <IdSelect onChange={(e)=> setParam({...param, verifytype:e.target.value})} value={param.verifytype} disabledText="Select Type" items={types} label='Verify Type' required />
               { profile?.canAddUser && <IdSelect onChange={(e)=> setParam({...param, specificUserId:e.target.value})} value={param.specificUserId} disabledText="Select Specific User" items={users} label='Select User' required />} 
               {( profile?.userType=='Admin' ||profile?.userType=='Auditor' || profile?.userType=='superadmin' ) && <IdSelect onChange={(e)=> setParam({...param, usertype:e.target.value})} value={param.usertype} disabledText="User Type" items={usertype} label='User Type' required />}
               
              </div>
              <div style={{display:'flex', flexDirection:'row'}}>
                <IdInput type='date' label='startdate' value={param.startdate} onChange={(e)=> setParam({...param, startdate:e.target.value})} required/>
                <IdInput type='date' label='enddate' value={param.enddate} onChange={(e)=> setParam({...param, enddate:e.target.value})} required/>
              </div>
            {isPlatformAdmin && <div style={{display:'flex', flexDirection:'row', alignItems:'flex-end'}}>
            {/* Optional — scopes the report to one bank's whole CompanyId, same as that bank's own
                Com-Owner(s) always see. Leaving it on "All Companies" keeps the old platform-wide
                behavior; this is what makes an Admin-run report on a company actually match that
                company's own report instead of Admin's narrower ByEmail-only lookup.
                Companies are sorted alphabetically (loadCompanies above) and this search box just
                narrows the dropdown's options client-side — there's no per-keystroke API call. */}
            <IdInput type='text' label='Search Company' value={companySearch} onChange={(e)=> setCompanySearch(e.target.value)} />
            <IdSelect
              onChange={onCompanyChange}
              value={param.companyId}
              disabledText="All Companies"
              items={companies
                .filter((c) => (c.name || '').toLowerCase().includes(companySearch.toLowerCase()))
                .map((c)=>({value:c.id, text:c.name}))}
              label='Company'
            />
            </div>}
            {( profile?.userType=='Admin' ||profile?.userType=='Auditor' || profile?.userType=='superadmin' ) && <div>
            <IdInput type='text' label='By Email' value={param.byEmail} onChange={(e)=> setParam({...param, byEmail:e.target.value})} />
            </div>}
              <div style={{fontSize:15, color:'red', textAlign:'center', padding:15, fontWeight:'bold'}}>{err}</div>
              {loading && <div  style={{display:'flex', justifyContent:'center', marginBottom:16, flexDirection:'column'}}>
                                  <img src={LoadingImg} style={{width:300, marginLeft:'auto', marginRight:'auto'}} />
                                  <span style={{ marginLeft:'auto', marginRight:'auto'}}>Loading...</span>
                                </div>}  
                {!loading && <div style={{display:'flex', justifyContent:'center', marginBottom:16}}>
                       <div style={{marginTop:16, marginBottom:16}}>
                        <button className='greenbutton' style={{width:'100%'}} type="submit">Get Report</button>
                        </div>         
                        
                </div>} 
            </form>
            <div>

            </div>
          </div>}  
       {isResult &&    <div>
          <h3> Total Units: {totalunit}</h3>
          <button type="button" className='greenbutton' onClick={onDownloadExcel}>Export Excel</button>
          <table className='specialtable'>
    <tr><th>Verify Type</th>
   {param.reportType=='details' && <th>The Request</th>}
    <th>Units</th>
    <th>Customer/Agent</th>
    <th>Email</th>
    {param.reportType=='details' && <th>Status</th>}
    {param.reportType=='details' && <th>Images</th>}
    {param.reportType=='details' && <th>Date</th>}
    </tr>
    {reports?.map((rep, idx) =>{return (
         <tr>
            <td>{rep.type}</td>
            {param.reportType=='details' && <td>{rep.params}</td>}
            <td>{rep.unitUsed}</td>
            <td>{rep.firstName} {rep.lastName}</td>
            <td>{rep.email}</td>
            {param.reportType=='details' && <td style={{color: rep.isSuccess ? 'green':'red', fontWeight:'bold'}}>{rep.isSuccess ? 'Pass':'Fail'}</td>}
            {param.reportType=='details' && <td>{rep.type==='facematch-liveness' && rep.hasImages &&
                <button type="button" className='no-print' onClick={()=>onViewImages(rep.verificationAttemptId)}>View Images</button>}</td>}
            {param.reportType=='details' && <td>{Constants.formatDate(rep.createDate) }</td>}
         </tr>
     )})}
   </table>
          </div>}
              
               
            </div>

<div>
{isResult && <div style={{display:'flex', justifyContent:'center', marginBottom:16}}>
                                <button className='greenbutton no-print' onClick={onPrint} >Print</button>
                                <button className=' no-print' onClick={onBack} >Back</button>
                              </div>} 
</div>

    </div>

    {imagesModal && (
      <div className='no-print' style={{ position:'fixed', top:0, left:0, right:0, bottom:0, background:'rgba(0,0,0,0.6)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }} onClick={onCloseImagesModal}>
        <div style={{ background:'white', borderRadius:8, padding:20, maxWidth:600, width:'90%', maxHeight:'85vh', overflowY:'auto' }} onClick={(e)=>e.stopPropagation()}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 }}>
            <h3 style={{margin:0}}>Face Match Images</h3>
            <button type="button" onClick={onCloseImagesModal}>Close</button>
          </div>
          {imagesModal==='loading' && <div>Loading images...</div>}
          {imagesModal==='error' && <div style={{color:'red'}}>Images were not retained for this verification attempt.</div>}
          {imagesModal!=='loading' && imagesModal!=='error' && (
            <div style={{ display:'flex', gap:16, flexWrap:'wrap', justifyContent:'center' }}>
              <div style={{textAlign:'center'}}>
                <div style={{fontWeight:'bold', marginBottom:6}}>NIN Reference Photo</div>
                <img src={imagesModal.referenceImage} alt='Reference' style={{maxWidth:250, borderRadius:6, border:'1px solid #ddd'}} />
              </div>
              <div style={{textAlign:'center'}}>
                <div style={{fontWeight:'bold', marginBottom:6}}>Captured Selfie</div>
                <img src={imagesModal.capturedImage} alt='Captured selfie' style={{maxWidth:250, borderRadius:6, border:'1px solid #ddd'}} />
              </div>
            </div>
          )}
        </div>
      </div>
    )}

   </IdLayout>
  )
}

export default Reports